module.exports = __webpack_public_path__ + "img/chalili.30c87976.jpg";